"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrDefault = void 0;
var getOrDefault = function (data, key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    var value = data.get(key);
    return !value ? defaultValue : value;
};
exports.getOrDefault = getOrDefault;
